import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/label-templates`;

export const labelApi = {
  list: (params = {}) => axios.get(API, { params }).then((r) => r.data),
  create: (body) => axios.post(API, body).then((r) => r.data),
  update: (id, body) => axios.put(`${API}/${id}`, body).then((r) => r.data),
  remove: (id) => axios.delete(`${API}/${id}`).then((r) => r.data),
  // 印刷1回=1イベント（既存の audit_log に記録。専用テーブルも履歴画面も作らない）
  logPrint: (body) => axios.post(`${API}/print-event`, body).catch(() => {}),
};
